import red from './resources/palettes/red.json';
import green from './resources/palettes/green.json';
import blue from './resources/palettes/blue.json';

export default {
    red,
    green,
    blue,
};
